var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUploadFileIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 28,
    viewBox: "0 0 14 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0909 6.36364V21C12.0909 23.8127 9.81273 26.0909 7 26.0909C4.18727 26.0909 1.90909 23.8127 1.90909 21V5.09091C1.90909 3.33455 3.33455 1.90909 5.09091 1.90909C6.84727 1.90909 8.27273 3.33455 8.27273 5.09091V18.4545C8.27273 19.1545 7.7 19.7273 7 19.7273C6.3 19.7273 5.72727 19.1545 5.72727 18.4545V6.36364H3.81818V18.4545C3.81818 20.2109 5.24364 21.6364 7 21.6364C8.75636 21.6364 10.1818 20.2109 10.1818 18.4545V5.09091C10.1818 2.27818 7.90364 0 5.09091 0C2.27818 0 0 2.27818 0 5.09091V21C0 24.8691 3.13091 28 7 28C10.8691 28 14 24.8691 14 21V6.36364H12.0909Z",
    fill: "#B23232"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadFileIcon);
export default __webpack_public_path__ + "static/media/upload_file_icon.a6c8046489414626ef7aa354a109a02f.svg";
export { ForwardRef as ReactComponent };